var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6663 8L9.99967 5.33333M12.6663 8L9.99967 10.6667M12.6663 8H5.99967M9.33301 14C8.54508 14 7.76486 13.8448 7.03691 13.5433C6.30895 13.2417 5.64752 12.7998 5.09037 12.2426C4.53322 11.6855 4.09126 11.0241 3.78973 10.2961C3.4882 9.56815 3.33301 8.78793 3.33301 8C3.33301 7.21207 3.4882 6.43185 3.78973 5.7039C4.09126 4.97595 4.53322 4.31451 5.09037 3.75736C5.64752 3.20021 6.30895 2.75825 7.03691 2.45672C7.76486 2.15519 8.54508 2 9.33301 2",
    stroke: "#FF4D42",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/log-out.58e85b763cdaa085fafed95207d4e87c.svg";
export { ForwardRef as ReactComponent };